/* Capture beforeinstallprompt event so we can trigger Add-to-Home-Screen on user gesture. */
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function isInstallAvailable() {
  return deferredPrompt !== null;
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

export function isIos() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export async function triggerInstall() {
  if (!deferredPrompt) return null;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((fn) => fn(false));
  return choice.outcome; // 'accepted' | 'dismissed'
}

export function onAvailabilityChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/**
 * Track portal visit count in localStorage so we only show install banner after Nth visit.
 */
export function recordPortalVisit(auraKey) {
  try {
    const key = `memouraa-visits-${auraKey}`;
    const count = parseInt(localStorage.getItem(key) || '0', 10) + 1;
    localStorage.setItem(key, String(count));
    return count;
  } catch {
    return 1;
  }
}

export function isInstallBannerDismissed() {
  try {
    return localStorage.getItem('memouraa-install-dismissed') === '1';
  } catch {
    return false;
  }
}

export function dismissInstallBanner() {
  try {
    localStorage.setItem('memouraa-install-dismissed', '1');
  } catch {
    /* ignore */
  }
}
